import { render, staticRenderFns } from "./ModalExito.vue?vue&type=template&id=05755632&scoped=true"
import script from "./ModalExito.vue?vue&type=script&lang=js"
export * from "./ModalExito.vue?vue&type=script&lang=js"
import style0 from "./ModalExito.vue?vue&type=style&index=0&id=05755632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05755632",
  null
  
)

export default component.exports